import * as React from "react";

import { Tab } from "@headlessui/react";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const TabsItems = ({ tabs }) => {
  return (
    <>
      <div className="w-full tabs-wrapper hidden md:block">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {tabs.title && <h2 className="text-left">{tabs.title}</h2>}
          <Tab.Group>
            <Tab.List className="tabs-buttons">
              {tabs.modular_blocks.map((tab) => (
                <Tab
                  key={tab.tab.title}
                  className={({ selected }) =>
                    classNames(selected ? "active" : "")
                  }
                >
                  {tab.tab.title}
                </Tab>
              ))}
            </Tab.List>
            <Tab.Panels className="mt-2">
              {tabs.modular_blocks.map((tab, idx) => (
                <Tab.Panel key={idx} className="w-full">
                  <div className="flex flex-row justify-center items-start w-full mx-auto space-x-6">
                    {tab.tab.modular_blocks.map((item) => (
                      <div
                        className="flex flex-col justify-center items-center max-w-[208px]"
                        key={item.item.title}
                      >
                        <div className="w-[208px] h-[208px]">
                          <img
                            src={item.item.file.url}
                            alt={item.item.title}
                            className="w-full h-full object-contain"
                          />
                        </div>
                        <span className="text-center item-title">
                          {item.item.title}
                        </span>
                      </div>
                    ))}
                  </div>
                </Tab.Panel>
              ))}
            </Tab.Panels>
          </Tab.Group>
        </div>
      </div>
      {tabs.disclaimer && (
        <p className="text-left container">{tabs.disclaimer}</p>
      )}
    </>
  );
};

export default TabsItems;
